import { useQuery } from 'react-query';
import useIntl from '../../../../hooks/useIntl';
import StateService from '../../../../services/stateService';
import messages from '../../messages';

export type UseAllStatesReturn = {
  states: Array<{ value: ?string, text: string }>,
  isLoading: boolean,
};

export default function useAllStates(): UseAllStatesReturn {
  const intl = useIntl();
  const queryKey = 'states';
  const statesService = new StateService();

  const { data, isLoading } = useQuery(
    queryKey,
    () => {
      return statesService.getAll();
    },
    { initialData: [], refetchOnWindowFocus: false },
  );

  const dataToReturn = !isLoading
    ? [
        // Add a default empty option
        { value: null, text: intl.formatMessage(messages.selectState) },
        ...data.map((state) => ({
          value: state.id,
          text: state.name,
        })),
      ]
    : null;

  return {
    states: dataToReturn,
    isLoading,
  };
}
